import {jQuery as $, lodash as _} from 'lib/shim';

import {IS_IOS_SAFARI} from 'defines';
import {lockScroll, unlockScroll} from 'util/scroll-lock';
import {prepareToggles} from 'util/toggle';



const SELECTOR = '.organism-header';

class Megamenu {

	constructor(menuWrapper, navContainer, subNavContainer, teaserContainer, navigationTree) {
		this.menuWrapper = menuWrapper;
		this.navContainer = navContainer;
		this.subNavContainer = subNavContainer;
		this.teaserContainer = teaserContainer;
		this.navigationTree = navigationTree;
		this.isOpen = false;

		$('main').on('click', () => {
			this.closeMegamenu();
		});

		$(window).on('scroll', () => {
			this.closeMegamenu();
		});
	}

	fadeOut (cb) {
		this.menuWrapper.animate({ opacity: 0 }, { done: cb });
	}

	fadeIn (cb) {
		this.menuWrapper.animate({ opacity: 1 }, { done: cb });
	}

	setSubNavigation (subItems) {
		this.subNavContainer.empty();

		if (subItems && subItems.length) {
			this.menuWrapper.addClass('wide');

			subItems.forEach((item, idx) => {
				item.link.removeClass('inactive');

				this.subNavContainer.append(item.link);

				if (idx === 0) {
					item.link.addClass('current');
				} else {
					item.link.removeClass('current');
				}

				item.link.on('click', () => {
					if (item.children && item.children.length) {
						return this.navigate(item.parent, item);
					}

					if (item.teaser) {
						this.showTeaser(item.teaser);
					}

					item.link.siblings().removeClass('current');
					item.link.addClass('current');
				});
			});

			return this.subNavContainer.fadeIn();
		}

		this.subNavContainer.fadeOut(0);
		this.menuWrapper.removeClass('wide');
	}

	showTeaser (teaser) {
		return this.teaserContainer.fadeOut(300, () => {
			this.teaserContainer.empty();
			this.teaserContainer.append(teaser.clone().contents());
			this.teaserContainer.fadeIn(300);
		});
	}

	closeMegamenu () {
		if (this.isOpen) {
			this.isOpen = false;
			this.teaserContainer.fadeOut(300, () => {
				this.teaserContainer.empty()
			});
			this.subNavContainer.fadeOut(300, () => {
				this.subNavContainer.empty();
			});

			this.fadeOut(() => {
				$('.megamenu').slideUp(300);

				this.menuWrapper.trigger('megamenu.close');
			});
		}
	}

	openMegamenu (index) {
		const menuRoot = this.navigationTree[index];

		if (menuRoot.children.length){
			this.navigate(menuRoot);
			this.isOpen = true;

			$('.megamenu').slideDown(300, () => {
				this.fadeIn();
			});
		} else {
			this.closeMegamenu();
		}
	}

	initMegamenuNavigation (navItems) {
		this.menuWrapper.on('megamenu.close', () => {
			navItems.removeClass('current');

			if(navItems.hasClass('active')) {
				navItems.filter('.active').removeClass('inactive');
			} else {
				navItems.removeClass('inactive');
			}
		});

		navItems.each((index, el) => {
			const $this = $(el);

			if( navItems.hasClass('active') && !$this.hasClass('active') ) {
				$this.addClass('inactive');
			}

			if(!$this.attr('href')) {
				$this.on('click', () => {
					if (!$this.hasClass('current')) {
						$this.addClass('current');
						$this.siblings().removeClass('current');
						$this.siblings().addClass('inactive');

						return this.openMegamenu(index);
					} else {
						$this.siblings('.active').removeClass('inactive');

						return this.closeMegamenu();
					}
				});
			}
		});
	}

	navigate (root, currentNode) {
		if (!root) return;
		this.menuWrapper.removeClass('wide');
		this.navContainer.empty();

		const inactivate = (isInactive) => {
			root.children.forEach(item => isInactive ? item.link.addClass('inactive') : item.link.removeClass('inactive'));
		};

		root.children.forEach(item => {
			const el = item.link;

			el.removeClass('current');
			this.navContainer.append(el);
			item.link.removeClass('inactive');

			if (currentNode) {
				item.link.addClass('inactive');

				if (currentNode === item) {
					item.link.addClass('current');
					item.link.removeClass('inactive');
				}
			} else {
				if (item.link.hasClass('summary')) {
					item.link.addClass('current');
				}
			}

			el.one('click', () => {
				if (item === currentNode || item.link.hasClass('summary')) {
					const prevParent = item.parent.parent;

					if (prevParent && prevParent !== root) {
						return this.navigate(prevParent, item.parent);
					}

					return this.navigate(root);
				}

				return this.navigate(root, item)
			});

		});

		this.setSubNavigation(currentNode && currentNode.children);

		const teaser = (currentNode && currentNode.teaser) || root && root.children && root.children[0] && root.children[0].teaser;

		if (teaser) {
			this.showTeaser(teaser);
		}
	}
}

class OrganismHeader {

	constructor(app, $element){
		if( !$.isSet($element.dataDuo('primed')) ){
			$element.dataDuo('primed', true);

			this._app = app;
			this._id = $.randomUuid(true);
			this._$element = $element;

			this._$pageHeader = this._$element.find('.page-header');
			this._$mobileTabletVersion = this._$element.find('.mobile-tablet-version').first();
			this._$burgerNavigationHolder = this._$element.find('.burger-menu').first();
			this._$burgerNavigationMenu = this._$burgerNavigationHolder.find('.burger-menu-content > .menu').first();
			this._$mobileTabletNav = this._$mobileTabletVersion.find('.menu-holder').first();
			this._$desktopVersion = this._$element.find('.desktop-version').first();
			this._$desktopNavigationMenuHolder = this._$element.find('.megamenu-wrapper').first();
			this._$desktopNavigationMenu = this._$element.find('.menu-holder > .megamenu').first();
			this._$metaNavigation = this._$desktopVersion.find('.meta-navigation-wrapper').first();
			this._$mainNavigation = this._$desktopVersion.find('.main-navigation-wrapper').first();
			this._$desktopLevel1HighlightFlyouts = this._$desktopVersion.find('.level-1-highlights .level-1-flyout');

			this._$burgerNavigationItems = this._$burgerNavigationHolder.find('.navigation-items');
			this._$mobileTabletMenuTree = this.buildNavigationTree(this._$burgerNavigationItems.children('.nav-item').clone().toArray());

			this._$megaMenuNavigationItems = this._$desktopNavigationMenuHolder.find('.navigation-items');
			this._$desktopMenuTree = this.buildNavigationTree(this._$megaMenuNavigationItems.children('.nav-item').clone().toArray());


			this.mobileTabletBurgermenu = new Megamenu(
				$('.megamenu .menu-holder'),
				$('.megamenu .menu-holder .menu'),
				$('.megamenu .menu-holder .submenu'),
				$('.megamenu .megamenu-teaser'),
				this._$mobileTabletMenuTree
			);

			this.desktopMegamenu = new Megamenu(
				$('.megamenu .menu-holder'),
				$('.megamenu .menu-holder .menu'),
				$('.megamenu .menu-holder .submenu'),
				$('.megamenu .megamenu-teaser'),
				this._$desktopMenuTree
			);

			this._prime();
		}

		return $element;
	}



	_prime(){
		this._$mobileTabletNav.each((_, el) => {
			let $nav = $(el),
				$toggle = $nav.find('.burger-button').first();

			$toggle.on('click', (e) => {
				e.preventDefault();

				if (!$nav.hasClass('open')) {
					$nav.addClass('open');
					this._$burgerNavigationHolder.addClass('open');

					if( IS_IOS_SAFARI ){
						lockScroll();
					}
				} else {
					$nav.removeClass('open');
					this._$burgerNavigationHolder.removeClass('open');

					if( IS_IOS_SAFARI ){
						unlockScroll();
					}
				}

				$('body').toggleClass('overlayed');
			});



			$(window).on('breakpointchange.app', (e, oldBreakpoint, newBreakpoint) => {
				if( (newBreakpoint === 'large') && $nav.hasClass('open')){
					$toggle.triggerHandler('click');
				}
			});

		});

		$(window).on('scroll', () => {
			this.makeSticky();
		});

		this._$pageHeader.each((_, header) => {
			this.desktopMegamenu.initMegamenuNavigation($(header).find('.main-nav-link'));
		});

		prepareToggles(this._$element);

		this.initMobileNavigation();
	}



	makeSticky() {
		const self = this;
		const $header = this._$element;
		const $pageHeader = $header.find('.page-header');
		const $headerHeight = $pageHeader.outerHeight(true);
		const $scrollTop =  $(window).scrollTop();

		if ($scrollTop > $headerHeight) {
			$header.removeClass('collapsed');
			if (!$header.hasClass('sticky')) {
				$header.addClass('sticky');
			}
			return;
		}
		if ($header.hasClass('sticky')) {
			$header.addClass('collapsed');
		}
		return $header.removeClass('sticky');
	}

	buildNavigationTree (items, parent) {
		return items.map(item => {
			const $item = $(item);
			const subItems = $item.children('.sub-items');
			const link = $item.children('.nav-link');
			let result = { parent: parent, link: link, item: $item, teaser: $item.children('.teaser-content').first() };

			if (subItems) {
				result.children = this.buildNavigationTree(subItems.children('.nav-item').toArray(), result)
			}

			return result;
		});
	}

	mobileNavigation (container, root, defaultRoot, event) {
		return (() => {
			let directionValue = '',
				newStartingPos = '';

			if ( event !== undefined && $(event.currentTarget).hasClass('prev') ){
				directionValue = '100%';
				newStartingPos = '-100%';
			} else {
				directionValue = '-100%';
				newStartingPos = '100%';
			}

			if ( event === undefined || !$(event.currentTarget).attr('href') ) {
				container.animate({
					'left': directionValue,
					'height' : 'toggle'
				}, 500, () => {
					container.css('left',newStartingPos);

					container.empty();
					container.removeClass('sub');

					if (root.item) {
						container.addClass('sub');
						const prev = root.item.clone();
						const prevLink = prev.children('.nav-link');

						prevLink.addClass('prev');
						prevLink.on('click', (e) => this.mobileNavigation(container, root.parent || defaultRoot, defaultRoot, e));

						container.append(prev);
					}

					root.children.forEach(item => {
						container.append(item.item);
						item.link.on('click', (e) => this.mobileNavigation(container, item, defaultRoot, e));
					});

					if (root.item) {
						if (container.children('.nav-item').first().children('.nav-link').hasClass('active')) {
							container.children('.nav-item').first().children('.nav-link').removeClass('active');
							container.children('.nav-item').first().next().children('.nav-link.summary').addClass('active');
						}
					}

					container.animate({
						'left': '0',
						'height' : 'toggle'
					}, 500);
				});
			}
		})();
	}

	initMobileNavigation () {
		const root = { children: this._$mobileTabletMenuTree };

		this.mobileNavigation(this._$burgerNavigationMenu, root, root);
	}
}



export function init(app){
	let $elements = $();

	$(SELECTOR).each(function(){
		let $this = $(this);

		$elements = $elements.add(new OrganismHeader(app, $this));
	});

	return $elements;
}
